import { v4 as uuidv4 } from 'uuid';
export var CLH_SESSION_ID = uuidv4();
